// extracted by mini-css-extract-plugin
module.exports = {"form__btn":"ff32b5"};